// @core/api/endpoints/user/delete_user.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/user';

/**
 * Delete user account
 * Permanently deletes a user account and all associated data. Supports both soft delete (default) and hard delete options. Publishes a user.deleted event for downstream cleanup.
 */
export async function DeleteUser(
  id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
